import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=0b5fa3f8&scoped=true&"
import script from "./SelectTag.vue?vue&type=script&lang=ts&"
export * from "./SelectTag.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTag.vue?vue&type=style&index=0&id=0b5fa3f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5fa3f8",
  null
  
)

export default component.exports